import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  PORTAL_SHORTCUT_CHANGED,
  PORTAL_SHORTCUT_DEFAULTS,
  formatPortalShortcutAria,
  loadPortalShortcutMap,
  type PortalShortcutId,
  type PortalShortcutMap,
} from './portalShortcuts';

const PortalShortcutContext = createContext<PortalShortcutMap>(PORTAL_SHORTCUT_DEFAULTS);

export const PortalShortcutProvider: React.FC<{ seatId: string; children: React.ReactNode }> = ({
  seatId,
  children,
}) => {
  const [map, setMap] = useState<PortalShortcutMap>(() =>
    typeof window === 'undefined' ? PORTAL_SHORTCUT_DEFAULTS : loadPortalShortcutMap(window.localStorage, seatId),
  );

  useEffect(() => {
    const read = () => setMap(loadPortalShortcutMap(window.localStorage, seatId));
    read();
    window.addEventListener(PORTAL_SHORTCUT_CHANGED, read);
    return () => window.removeEventListener(PORTAL_SHORTCUT_CHANGED, read);
  }, [seatId]);

  return <PortalShortcutContext.Provider value={map}>{children}</PortalShortcutContext.Provider>;
};

export function usePortalShortcutMap(): PortalShortcutMap {
  return useContext(PortalShortcutContext);
}

export function usePortalShortcutAria(id: PortalShortcutId): string {
  const map = usePortalShortcutMap();
  return formatPortalShortcutAria(map[id]);
}
